// src/shared/components/PrintContainer.tsx
import { Box, Typography } from "@mui/material";
import React from "react";
import { ReactComponent as GCommerceIcon } from "../../../assets/icons/dashboard-title.svg";

interface PrintContainerProps {
  title: string;
  propertyTitle?: string | null;
  children: React.ReactNode;
}

const PrintContainer = ({
  title,
  propertyTitle,
  children,
}: PrintContainerProps) => {
  return (
    <Box className="report-container">
      {/* Change: Remove inline display: none and use class print-only-section */}
      <Box className=" print-only-header" sx={{ display: "none", mb: 4 }}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "flex-end",
            borderBottom: "2px solid #1e2d24",
            pb: 1,
          }}
        >
          <Box>
            <Box sx={{ mb: 0.5 }}>
              <GCommerceIcon style={{ height: "32px", width: "auto" }} />
            </Box>
            <Typography variant="h6" sx={{ color: "#666" }}>
              {title}
            </Typography>
          </Box>
          <Box sx={{ textAlign: "right" }}>
            <Typography variant="body2">
              Property: {propertyTitle || ""}
            </Typography>
            <Typography variant="body2">
              Date: {new Date().toLocaleDateString()}
            </Typography>
          </Box>
        </Box>
      </Box>

      <Box className="report-content">{children}</Box>

      {/* Change: Remove inline display: none and use class print-only-section */}
      <Box
        className=" print-only-footer"
        sx={{
          display: "none",
          mt: 4,
          pt: 2,
          borderTop: "1px solid #ccc",
          textAlign: "center",
        }}
      >
        <Typography variant="caption">
          Powered by GCommerce Summit • Confidential Performance Report
        </Typography>
      </Box>
    </Box>
  );
};

export default PrintContainer;
